import axios from 'axios';
import { API3_HOST } from '../helpers/urlHelper';

export const getTurnover = (startDate, endDate) => {
  return axios({
    method: 'get',
    url: `${API3_HOST}/turnover?startDate=${startDate}&endDate=${endDate}`
  });
};
